import _extends from "@babel/runtime/helpers/extends";
import React, { useImperativeHandle } from 'react';
import { useScaleControl } from './useScaleControl';
export * from './useScaleControl';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    scaleControl
  } = useScaleControl(props);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useImperativeHandle(ref, () => _extends({}, props, {
    scaleControl
  }), [scaleControl]);
  return null;
});